import React, { useEffect, useState } from "react";
import { getActiveAds } from "../../api";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./AdsPage.css";

const PAGE_SIZE = 10;

const AdsPage = () => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === "ar";
  const navigate = useNavigate();

  const [ads, setAds] = useState([]);
  const [pagination, setPagination] = useState({});
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);

  const fetchAds = async () => {
    setLoading(true);
    try {
      const data = await getActiveAds({
        page,
        pageSize: PAGE_SIZE,
        search,
      });
      setAds(data.ads || []);
      setPagination(data.pagination || {});
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAds();
    // eslint-disable-next-line
  }, [page, search]);

  return (
    <main className={`ads-page ${isRTL ? "rtl" : "ltr"}`}>

      {/* HEADER CONTAINER */}
      <div className="ads-header-wrapper">
        <h1>{t("All Ads")}</h1>

        <input
          type="text"
          className="ads-search"
          placeholder={t("Search ads...")}
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            setPage(1);
          }}
        />
      </div>

      {/* LOADER */}
      {loading && <div className="ads-loader">{t("Loading…")}</div>}

      {/* GRID – FULL WIDTH */}
      <section className="ads-grid">
        {ads.map((ad) => (
          <article
            key={ad.id}
            className="ad-card"
            onClick={() => navigate(`/ads/${ad.id}`)}
          >
            <img
              className="ad-thumb"
              src={ad.image_url || "/images/default-ad.png"}
              alt={ad.title}
              loading="lazy"
            />

            <div className="ad-info">
              <h3>{ad.title}</h3>
              <p className="muted">{ad.snippet}</p>

              {ad.price && Number(ad.price) > 0 && (
                <div className="ad-price">
                  {t("Price")}: <strong>{ad.price}</strong>
                </div>
              )}

              <button
                className="ad-more-btn"
                onClick={(e) => {
                  e.stopPropagation();
                  navigate(`/ads/${ad.id}`);
                }}
              >
                {t("More Details")}
              </button>
            </div>
          </article>
        ))}
      </section>
      {/* PAGINATION */}
{pagination.total > PAGE_SIZE && (
  <div className="ads-pagination">
    {page > 1 && (
      <>
        <button onClick={() => setPage(1)}>
          {t("First")}
        </button>

        <button onClick={() => setPage(page - 1)}>
          {t("Previous")}
        </button>
      </>
    )}

    {Array.from({
      length: Math.ceil(pagination.total / PAGE_SIZE)
    }).map((_, i) => {
      const p = i + 1;
      if (
        p === 1 ||
        p === Math.ceil(pagination.total / PAGE_SIZE) ||
        (p >= page - 1 && p <= page + 1)
      ) {
        return (
          <button
            key={p}
            className={p === page ? "active" : ""}
            onClick={() => setPage(p)}
          >
            {p}
          </button>
        );
      }
      return null;
    })}

    {page < Math.ceil(pagination.total / PAGE_SIZE) && (
      <>
        <button onClick={() => setPage(page + 1)}>
          {t("Next")}
        </button>

        <button
          onClick={() =>
            setPage(Math.ceil(pagination.total / PAGE_SIZE))
          }
        >
          {t("Last")}
        </button>
      </>
    )}
  </div>
)}

    </main>
  );
};

export default AdsPage;
